import { mergeStyleSets } from "@fluentui/react";
import { constants } from "library/constants";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useUnmount } from "react-use";
import { TimelineType } from "types/types";
import { AppContext } from "../../AppContext";
import { useCurrentRoute } from "../../config/routes";
import { useSelector } from "../../store/hooks";
import AttachmentsSection from "./AttachmentsTab/AttachmentsSection";
import FinanceSection from "./FinanceTab/FinanceSection";
import GeneralSection from "./GeneralAndVehicleTab/GeneralSection/GeneralSection";
import VehicleInfoSection from "./GeneralAndVehicleTab/VehicleInfoSection/VehicleInfoSection";
import HistorySection from "./HistoryTab/HistorySection";
import PremiumBooking from "./PremiumBooking/PremiumBooking";

const VehicleForm = ({ vehicle, props, initialValues }) => {
  const route = useCurrentRoute();
  const defaultSettings = useSelector((s) => s.vehicle.fleetDefaultSettings);
  const appContext = useContext(AppContext);
  const tab = useSelector((s) => s.vehicle.tab);
  const vehicleAppSettings = useSelector((s) => s.vehicle.vehicleAppSettings);

  const isTradeLicensePlate =
    route === "createTradeVehicle" || vehicle?.isTradeLicensePlate;

  const isReadOnlyMode = route === constants.readOnlyVehicle;

  useUnmount(() => appContext.clearFormNotifications());

  const isBookingTab = tab === "booking-vehicle-form";
  const isHistoryTab = tab === "history-table";
  const isAttachmentsTab = tab === "attachments-table";
  const isFormTab = !isBookingTab && !isHistoryTab && !isAttachmentsTab;
  const { t } = useTranslation();

  return (
    <>
      {isFormTab && (
        <div id="general-vehicle-form">
          <GeneralSection
            formikProps={props}
            defaultSettings={defaultSettings}
            vehicle={vehicle}
            initialValues={initialValues}
            route={route}
          />
        </div>
      )}
      {isFormTab && !isTradeLicensePlate && (
        <div id="vehicle-form">
          <VehicleInfoSection
            defaultSettings={defaultSettings}
            formikProps={props}
            vehicle={vehicle}
            initialValues={initialValues}
            route={route}
          />
        </div>
      )}
      {isFormTab && (
        // The #finance-vehicle-form anchor lives inside FinanceSection, on the
        // premium lines - see the comment there.
        <div>
          <FinanceSection
            formikProps={props}
            defaultSettings={defaultSettings}
            vehicle={vehicle}
            initialValues={initialValues}
            route={route}
          />
        </div>
      )}
      {((isBookingTab && !isHistoryTab && !isAttachmentsTab) ||
        isReadOnlyMode) &&
        vehicleAppSettings?.VEHICLE_TIMELINE_TYPES.includes(
          TimelineType.VEHICLE_PREMIUM_BOOKINGS
        ) && (
          <div
            id="booking-vehicle-form"
            className={vehicleFormClasses.bookingContainer}
          >
            <PremiumBooking />
          </div>
        )}

      {((!isBookingTab && isHistoryTab) || isReadOnlyMode) &&
        vehicleAppSettings?.HAS_VEHICLE_HISTORY && (
          <div
            id="history-table"
            className={vehicleFormClasses.vehicleHistoryContainer}
          >
            <HistorySection vehicle={vehicle} route={route} />
          </div>
        )}

      {(isAttachmentsTab || isReadOnlyMode) &&
        vehicleAppSettings?.HAS_VEHICLE_ATTACHMENTS &&
        vehicle?.vehicleId && (
          <div
            id="attachments-table"
            className={vehicleFormClasses.vehicleHistoryContainer}
          >
            <AttachmentsSection vehicle={vehicle} route={route} />
          </div>
        )}
    </>
  );
};

export const vehicleFormClasses = mergeStyleSets({
  container: {
    display: "flex",
    flexWrap: "wrap",
    padding: "10px",
  },
  item: {
    padding: "20px",
    width: "49%",
    "@media(min-width: 1500px)": {
      width: "33%",
    },
  },
  commentItem: {
    padding: "10px",
    margin: "0 auto",
    width: "98%",
  },
  commentItemGrid: {
    padding: "20px",
    margin: "0 auto",
    width: "49%",
  },
  fullWidthFormItem: {
    width: "100%",
    padding: "20px",
  },
  bookingContainer: {
    width: "100%",
  },
  vehicleHistoryContainer: {
    width: "100%",
    padding: "20px 50px",
  },
});

export default VehicleForm;
